<template>
  <div id="app" class="h-full">
    <router-view />
    <FeedbackDialog v-if="feedbackVisible"/>
    <ConfirmationChangesDialog/>
    <license-dialog :dialogOpen="dialogLicenseOpen" @toggleDialog="toggleDialog" @toggleDialogClose="toggleDialogLicenseClose" :mobileVersion="isLower1024"/>
    <wizard-dialog :dataWizard="dataWizard" :dialogOpen="dialogWizardOpen" @toggleDialog="toggleDialogWizard" @toggleDialogClose="toggleDialogWizardClose" :mobileVersion="isLower1024"/>
    <v-tour name="myTour" :steps="tourFirstStepsSteps" :options="toursOptions" :callbacks="tourFirstStepsCallbacks"></v-tour>
    <!-- Region para mensajes accesibles -->
    <div id="sr-only-live-region"
      class="sr-only"
      aria-live="assertive"
      aria-atomic="true">
    </div>
  </div>
</template>
<script>
import FeedbackDialog from '@/components/FeedbackDialog.vue'
import LicenseDialog from '@/components/license/LicenseDialog.vue'
import WizardDialog from '@/components/wizard/WizardDialog.vue'
import ConfirmationChangesDialog from '@/components/ConfirmationChangesDialog.vue'
import { checkLicense } from '@/services/configurations/licenseUser/checkLicense'
import { checkWizard } from '@/services/configurations/licenseUser/checkWizard'
import { bus } from '@/main'

export default ({
  components: {
    FeedbackDialog,
    LicenseDialog,
    WizardDialog,
    ConfirmationChangesDialog,
  },
  watch: {
    // Disparador de eventos solo la primera vez que se llega a una ruta privada de navegación
    $route: function () {
      if (!this.actualRoutePublic) {
        if (!this.controlFlagPatchNotes) {
          this.controlPatchNotes()
        }
        if (!this.controlFlagWizard && this.role === 'Administrador') {
          this.controlWizard()
        }
        if (!this.controlFlagLicense) {
          this.controlLicense()
        }
      }
    },
    isIdle: function (value, oldValue) {
      if (this.autoIdle && value && !this.actualRoutePublic) {
        this.$store.dispatch('auth/logout')
        this.doFeedback('Su sesión ha caducado, es necesario volver a iniciar sesión', 'info', 5000)
      }
    }
  },
  data: function () {
    return {
      controlFlagPatchNotes: false, 
      dialogLicenseOpen: false,
      // Wizard
      dialogWizardOpen: false,
      dataWizard: null,
      //
      toursOptions: {
        // highlight: true,
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: 'Omitir',
          buttonPrevious: 'Volver',
          buttonNext: 'Siguiente',
          buttonStop: 'Finalizar'
        }
      },
      tourFirstStepsCallbacks: {
        onSkip: this.onSkipTourFirstSteps,
        onFinish: this.onSkipTourFirstSteps,
      },
      tourFirstStepsSteps: [
        {
          target: '[data-v-step="0"]', // We're using document.querySelector() under the hood
          content: 'Primeros pasos en <strong>EdasNEO</strong>',
          params: {
            placement: 'right'
          },
          before: type => new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve()
            }, 500)
          })
        },
        {
          target: '[data-v-step="1"]',
          content: 'Dirígete a la sección de certificados para subir nuevo certificado',
          params: {
            placement: 'right'
          },
          before: type => new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve()
            }, 500)
          })
        },
        {
          target: '[data-v-step="2"]',
          content: 'Sube a la plataforma tu certificado y sigue los pasos para generar y vincularle una empresa',
          params: {
            placement: 'top'
          },
          before: type => new Promise((resolve, reject) => {
            this.$router.push({ name: 'certificates' })
            setTimeout(() => {
              resolve()
            }, 500)
          })
        },
        {
          target: '[data-v-step="3"]',
          content: 'Dirígete a la sección de empresas para comprobar que se ha generado correctamente',
          params: {
            placement: 'right'
          },
          before: type => new Promise((resolve, reject) => {
            this.$router.push({ name: 'companies' })
            setTimeout(() => {
              resolve()
            }, 500)
          })
        },
        {
          target: '[data-v-step="4"]',
          content: 'Comprueba en el grid o en el detalle de la empresa que el certificado está vinculado y la empresa esta activa',
          params: {
            placement: 'top'
          },
          before: type => new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve()
            }, 500)
          })
        }
      ],
    }
  },
  created: async function () {
    // Limpiamos cambios posibles y desactivamos dialogo de confirmacion de cambios de formulario
    this.$store.commit('app/setFormChanges', false)
    this.$store.commit('app/setShowModalConfirmChanges', false)
    
    this.$store.dispatch('app/updateFrontColors')
    this.$store.dispatch('app/updateVersion')
    this.$store.dispatch('app/updatecontrolFlagLicense', false)
    this.$store.dispatch('app/updatecontrolFlagWizard', false)
    if (!this.actualRoutePublic) {
      await this.$store.dispatch('app/getColors')
    }
    this.$store.dispatch('app/updateFrontColors')
  },
  mounted () {  
    document.title = process.env.VUE_APP_TITLE
    this.$root.$on('setControlFlagPatchNotes', () => {
      this.controlFlagPatchNotes = true
    })
    this.updateLangi18n()

    this.loadGridPersistedMixin()
    
    // Descomentar para arrancar tour
    // this.$tours.myTour.start()
  },  
  computed: {
    actualRoutePublic () {
      return this.$store.getters['app/actualRoutePublic']
    },
    feedbackVisible () {
      // Propuestas deshabilitadas
      return false
      // return !this.actualRoutePublic
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    controlFlagLicense () {
      return this.$store.getters['app/controlFlagLicense']
    },
    controlFlagWizard () {
      return this.$store.getters['app/controlFlagWizard']
    },
    isIdle () {
      return this.$store.state.idleVue.isIdle
    },
    autoIdle () {
      return this.$store.getters['app/autoIdleTime']
    },
    role: function () {
      return this.$store.getters['auth/role']
    }
  },
  methods: {
    updateLangi18n () {
      const actualLang = this.$store.getters['app/selectedLang'] || 
        process.env.VUE_APP_I18N_LOCALE ||
        'es-ES'

      // console.log('updateLang', actualLang)
      this.setLocale(actualLang, bus)
    },
    onSkipTourFirstSteps () {
    },
    controlPatchNotes () {
      if (!this.isEqualVersions()) {
        var self = this
        setTimeout(() => {
          self.doFeedback('EdasNEO se ha actualizado con una nueva versión', 'info')
          if (self.isLower1024) self.$root.$emit('openNotesPatchMobile')
          else self.$root.$emit('openNotesPatch')
        }, 1500)
      }
    },
    isEqualVersions () {
      const splitOld= this.$store.getters['app/lastVisitedPatchNotes'].split('.')
      const splitActual = this.$store.getters['app/version'].split('.')
      if (splitOld[0] === splitActual[0] && splitOld[1] === splitActual[1] && splitOld[2] === splitActual[2]) return true
      return false
    },
    controlLicense: async function () {
      try {
        const response = await checkLicense()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          if (response.Respuesta) {
            this.$store.dispatch('app/updatecontrolFlagLicense', true)
          } else {
            this.toggleDialog()
          }
        }
      } catch (error) {
        this.doFeedback()
      }
    },
    controlWizard: async function () {
      try {
        const response = await checkWizard()
        // TODO
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          if (!response.PendienteConfigurar) {
            this.$store.dispatch('app/updatecontrolFlagWizard', true)
          } else {
            this.dataWizard = {
              ListaSteps: response.ListaSteps,
              CurrentStep: response.CurrentStep,
              idPaqueteContratacion: response.idPaqueteContratacion,
            }
            this.toggleDialogWizard()
          }
        }
      } catch (error) {
        this.doFeedback()
      }
    },
    toggleDialog: function () {
      this.dialogLicenseOpen = !this.dialogLicenseOpen
      if (!this.dialogLicenseOpen) this.controlFlagLicense = true
    },
    toggleDialogWizard: function () {
      this.dialogWizardOpen = !this.dialogWizardOpen
      if (!this.dialogWizardOpen) this.controlFlagWizard = true
    },
    toggleDialogLicenseClose () {
      if (this.dialogWizardOpen) this.toggleDialogWizard()
    },
    toggleDialogWizardClose () {
      if (this.dialogLicenseOpen) this.toggleDialog()
    },
  }
})
</script>

<style lang="scss" src="@/assets/scss/overrides.scss">
</style>
